'use strict';

var ajax = require('./ajax'),
    minicart = require('./minicart'),
    util = require('./util'),
    nameHolder = document.querySelector('#dtName'),
    amountHolder = document.querySelector('#dtAmount');

function updatePlaceholder() {
    let formNameInput = document.querySelector('#dwfrm_giftcert_purchase_recipient'),
        formAmountSelect = document.querySelector('select[name=dwfrm_giftcert_purchase_amount]');

    // set initial values (necessary for when editing a gift cert.)
    nameHolder.textContent = formNameInput.value;
    amountHolder.textContent = formAmountSelect.options[formAmountSelect.selectedIndex].text;

    // Update Name
    formNameInput.addEventListener('input', function(event) {
        nameHolder.textContent = formNameInput.value;
    });

    // Update Amount
    $(formAmountSelect).on('change', function(event) {
        amountHolder.textContent = formAmountSelect.options[formAmountSelect.selectedIndex].text;
    });
}

var setAddToCartHandler = function (e) {
    e.preventDefault();
    var form = $(this).closest('form');

    if(!form.valid()) return false;

    var options = {
        url: util.ajaxUrl(form.attr('action')),
        method: 'POST',
        cache: false,
        data: form.serialize()
    };
    $.ajax(options).done(function (response) {
        if (response.success) {
            ajax.load({
                url: Urls.minicartGC,
                data: {lineItemId: response.result.lineItemId},
                callback: function (response) {
                    minicart.show(response);
                    form.find('input,textarea').val('').removeClass('valid');
                    
                    form.find('select').each(function(){
                        this.selectedIndex = 0;
                        $(this).trigger('change');
                    });

                    if(nameHolder) {
                        nameHolder.textContent = '';
                    }
                }
            });
        }

        else {
            form.find('span.error').hide();
            for (var id in response.errors.FormErrors) {
                var $errorEl = $('#' + id).addClass('error').removeClass('valid').next('.error');
                if (!$errorEl || $errorEl.length === 0) {
                    $errorEl = $('<span for="' + id + '" generated="true" class="error" style=""></span>');
                    $('#' + id).after($errorEl);
                }
                $errorEl.text(response.errors.FormErrors[id].replace(/\\'/g, '\'')).show();
            }
        }
    }).fail(function (xhr, textStatus) {
        // failed
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        } else {
            window.alert(Resources.SERVER_CONNECTION_ERROR);
        }
    });
};

exports.init = function () {
    $('#AddToBasketButton').on('click', setAddToCartHandler);

    if(nameHolder) {
        updatePlaceholder();
    }
};



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/giftcert.js